import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';

class TriggerTag extends Component {
    constructor(props){
        super(props);
        this.state = {
            tags: props.tagsList,
            selectedTags: props.selectedTag
        }
    }

    selectTags = (tagElement) =>{
        const { updateValue, triggerIndex } = this.props;
        const selectOption = this.state.selectedTags;
        let selectedTags = [...selectOption, tagElement];
        if(selectOption.some(option => option.value == tagElement.value)){
            selectedTags = selectOption.filter(item => item.value != tagElement.value);
        }
        let values = selectedTags.map(tag => tag.value).join(",");
        this.setState({ selectedTags }, () => updateValue(triggerIndex, values));
    }

    render (){
        const { selectedTags } = this.state 
        const { name } = this.props.triggerType
        return <div className="mt-3">
        <CreatableSelect placeholder={name=="Language" ? `Search Language` : `Search or Create tag...`} className="selectpicker selectpicker-sm" classNamePrefix="selectpicker" isClearable options={this.props.tagsList} onChange={event=>this.selectTags(event)} value="" />
        {selectedTags && selectedTags.length > 0 ? <div className="d-flex w-100 flex-wrap w-100 mt-1">
          {selectedTags.map((item, index)=> <div className="badge bg-light text-dark rounded-pill border me-1 mt-1 px-3 d-flex align-items-center" style={{ top: 0, maxWidth: '100%' }} key={index}>
            <span className="text-break" style={{ whiteSpace: 'normal' }}>{item.label}</span>
            <Button variant='close' className='btn-text p-0 ms-2' onClick={()=> this.selectTags(item)}></Button>
          </div>)}
        </div> : null}
      </div>
    }
}

export default TriggerTag